export default {root:{'abstract':true,use:'root'}};